var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDatabaseTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 58.201 58.201",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.6,34.201c-6.617,0-12,5.383-12,12s5.383,12,12,12s12-5.383,12-12S51.218,34.201,44.6,34.201z M44.6,56.201 c-5.514,0-10-4.486-10-10s4.486-10,10-10s10,4.486,10,10S50.114,56.201,44.6,56.201z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6,45.201h-5v-5c0-0.553-0.447-1-1-1s-1,0.447-1,1v6c0,0.553,0.447,1,1,1h6c0.553,0,1-0.447,1-1 S51.153,45.201,50.6,45.201z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.943,43.038c1.092-5.065,4.751-9.173,9.541-10.919c-3.006,0.507-6.431,0.846-10.277,0.951 c-0.87,0.027-1.74,0.041-2.606,0.041c-0.869,0-1.742-0.014-2.614-0.042c-7.341-0.201-13.191-1.238-17.403-2.717 C4.604,29.685,2.909,28.899,1.6,28v7.111v0.5v0.5V37.4c2.846,2.971,12.394,5.711,25,5.711 C27.744,43.111,28.852,43.081,29.943,43.038z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.236,29.965c0.326,0.009,0.651,0.018,0.982,0.023C25.674,29.996,26.135,30,26.6,30s0.926-0.004,1.383-0.011 c0.33-0.005,0.656-0.015,0.982-0.023c0.116-0.003,0.234-0.005,0.349-0.008c11.253-0.359,19.648-2.915,22.286-5.668V23v-0.5V22 v-7.111C46.733,18.232,36.444,20,26.6,20s-20.133-1.768-25-5.111V22v0.5V23v1.289c2.638,2.754,11.033,5.31,22.286,5.668 C24.002,29.96,24.12,29.962,24.236,29.965z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6,11.306V9.5V9c0-0.168-0.056-0.319-0.135-0.458C50.343,4.241,41.715,0,26.6,0C11.523,0,2.904,4.22,1.747,8.51 C1.662,8.657,1.6,8.818,1.6,9v0.5v1.806C4.437,14.267,13.917,17,26.6,17S48.764,14.267,51.6,11.306z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6,46.201c0-0.018,0.003-0.035,0.003-0.053c-0.977,0.031-1.972,0.053-3.003,0.053c-12.346,0-20.866-2.29-25-5.201v8.201 c0,0.162,0.043,0.315,0.117,0.451c1.181,4.895,11.747,8.549,24.883,8.549c2.942,0,5.744-0.192,8.351-0.532 C31.684,54.916,29.6,50.799,29.6,46.201z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabaseTimer);
export default __webpack_public_path__ + "static/media/databaseTimer.19c7ac6d.svg";
export { ForwardRef as ReactComponent };